import React from 'react';

export default ({allRowsCount, handleRowsSelect, selectedRowsCount, className}) => {
  const getActiveClass = value => {
    if (value === selectedRowsCount) return 'active';
    return '';
  };

  const handleInnerRowsSelect = value => () => {
    handleRowsSelect(value, allRowsCount);
  };

  return (
    <div className={`ect-rows-selector ${className}`}>
      <div onClick={handleInnerRowsSelect(10)} className={`ect-row ${getActiveClass(10)}`}>10</div>
      <div onClick={handleInnerRowsSelect(25)} className={`ect-row ${getActiveClass(25)}`}>25</div>
      <div onClick={handleInnerRowsSelect(50)} className={`ect-row ${getActiveClass(50)}`}>50</div>
      <div onClick={handleInnerRowsSelect(100)} className={`ect-row ${getActiveClass(100)}`}>100</div>
      <div onClick={handleInnerRowsSelect(0)} className={`ect-row ${getActiveClass(0)}`}>All</div>
      <div className='ect-all-rows'>records out of {allRowsCount} total</div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/app/Components/RowsSelector.jsx